var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { onError } from "@ane/core/lib/decorators/OnError";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import { parseError } from "@ane/core/lib/utils/ErrorUtils";
import { noCache } from "../../services/middlewares/NoCacheMiddleware.js";
import { getUnifiedApiVersion } from "./ExpAPIVUnified.constants.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ExperimentationGroupResource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.default, "/workspaces/", parseError);
  }
  getExperimentationGroups(workspaceId) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/experimentation-groups?api-version=${getUnifiedApiVersion()}`;
      return yield this._get(address);
    });
  }
  getAudienceFilters(payload) {
    return __async(this, null, function* () {
      const { workspaceId, experimentationGroup, includeArchived = true } = payload;
      const address = `${workspaceId}/experimentation-groups/${experimentationGroup}/audience-filters?api-version=${getUnifiedApiVersion()}&isArchived=${includeArchived}`;
      return yield this._get(address);
    });
  }
};
__decorateClass([
  onError({ message: `An error occured while getting the experimentation groups.` })
], ExperimentationGroupResource.prototype, "getExperimentationGroups", 1);
__decorateClass([
  onError({ message: `An error occured while getting the audience filters.` })
], ExperimentationGroupResource.prototype, "getAudienceFilters", 1);
ExperimentationGroupResource = __decorateClass([
  noCache(),
  WPSProxyConverter()
], ExperimentationGroupResource);
const ExperimentationGroup_resource = new ExperimentationGroupResource();
export {
  ExperimentationGroupResource,
  ExperimentationGroup_resource as default
};
//# sourceMappingURL=ExperimentationGroup.resource.js.map
